import React from 'react';

import IconLink from './IconLink';

export default function FacebookIcon() {
  return (
    <IconLink
      href="https://www.facebook.com/onetogrowonpod"
      title="Follow us on Facebook!"
      path="M19 6h5v-6h-5c-3.86 0-7 3.14-7 7v3h-4v6h4v16h6v-16h5l1-6h-6v-3c0-0.542 0.458-1 1-1z"
    />
  );
}
